import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from './core/services/seo.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  private seoService = inject(SeoService);

  title = 'simpleproof-verification';

  ngOnInit(): void {
    this.seoService.setDefaultTags();
  }
}
